/**
 * Do not edit directly
 */

export default "PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMxMTE7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5JY29uPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik02LjY2LDE1bC43Ni01LjMySDEuMzdMOS4zNCwxLDguNTgsNi4yOGg2LjA1Wm0tMy02LjMySDguNThMOC4xMSwxMmw0LjI2LTQuNjhINy40Mkw3Ljg5LDRaIi8+PC9zdmc+";